(ns frontend.view.nev.zap-vault.tab-configuration
  (:require [clojure.string :as string]
            [common.localization :as loc]
            [common.util :as cu]
            [frontend.ui.component.image-cropper.view :as image-cropper]
            [frontend.view.nev.zap-vault.event :as event]
            [frontend.view.nev.zap-vault.sub :as sub]
            [re-frame.core :as rf]
            [ui.components.button.view :as button]
            [ui.components.layout.footer :as footer]
            [ui.components.radix-ui.tooltip.view :as tooltip]
            [ui.components.rich-text.tiptap :as tiptap]
            [ui.components.text.view :as text]
            [ui.editors.labelled-input.view :as labelled-input]))

(defn logo-config
  []
  (let [logo-url @(rf/subscribe [::sub/vault-logo])
        valid-image-url? (and (not (cu/blank-value? logo-url))
                              (string/starts-with? (str logo-url) "http"))]
    [:div
     {:class "flex flex-col gap-2 border border-solid border-base-light-border-paler py-4"}
     [text/h2
      (loc/tr :vault-config/vault-logo)]
     [:div
      {:class "flex flex-row gap-2 align-items-center"}
      (when valid-image-url?
        [:img
         {:class "max-w-[250px] max-h-[50px] w-auto h-auto object-contain\n"
          :src   logo-url}])
      [image-cropper/modal-image-cropper
       {:target-height    50
        :target-width     250
        :dropzone-content (when valid-image-url?
                            [:div
                             {:class (button/link-style nil)}
                             (loc/tr :replace-logo)])
        :round?           false
        :on-cropped       (fn [base64-image]
                            (rf/dispatch [::event/upload-logo base64-image]))
        :size             :xs}]]]))

(defn view
  []
  (let [config @(rf/subscribe [::sub/config-with-updates])
        vault @(rf/subscribe [::sub/vault-with-updates])
        changes @(rf/subscribe [::sub/vault-and-config-changes])]
    [:div
     {:class "flex flex-col gap-2 border border-solid border-base-light-border-paler"}
     [:div
      {:class "flex flex-col gap-1 p-4 pb-0"}
      [text/h2
       (loc/tr :zap-vault-configuration)]
      [text/info-text
       (loc/tr :zap-vault-configuration-info)]]
     [:div
      {:class "flex flex-col gap-2 px-4 bg-base-regular items-start"}
      [:div
       {:class "flex flex-col gap-2 w-full max-w-[600px]"}
       [logo-config]
       [labelled-input/view
        {:label     (loc/tr :zap-vault/name)
         :value     (:zap-vault/name vault)
         :data-type :data.type/text-simple
         :on-change (fn [v]
                      (rf/dispatch [::event/vault-change :zap-vault/name v]))}]
       [labelled-input/view
        {:label     (loc/tr :zap-vault/description)
         :value     (:zap-vault/description vault)
         :data-type :data.type/text-richtext
         :on-change (fn [v]
                      (rf/dispatch [::event/vault-change :zap-vault/description v]))}]

       [labelled-input/view
        {:label     [:div
                     {:class "flex flex-row gap-2"}
                     [:span
                      (str (loc/tr :zap-vault/archive-date) " (" (cu/str-trim-lcase (loc/tr :recommended)) ")")]
                     [tooltip/view
                      [:i.fa.fa-info-circle]
                      (loc/tr :zap-vault-archive-date-info)]]
         :value     (:zap-vault/archive-date vault)
         :data-type :data.type/date
         :on-change (fn [v]
                      (rf/dispatch [::event/vault-change :zap-vault/archive-date v]))}]

       [labelled-input/view
        {:label     (loc/tr :vault-config/logout-url)
         :value     (:vault-config/logout-url config)
         :data-type :data.type/text-url
         :disabled? (false? (:vault-config/allow-url-modification? config))
         :on-change (fn [v]
                      (rf/dispatch [::event/config-change :vault-config/logout-url v]))}]

       (if (false? (:vault-config/allow-unauthorized-message-modification? config))
         [:<>
          [labelled-input/label-elem
           {:label (loc/tr :vault-config/no-access-message)}]
          [:div
           {:class "[&_.ProseMirror]:py-0 [&_.ProseMirror]:border-0 [&_.ProseMirror]:bg-transparent"}
           [tiptap/viewer
            {:value (:vault-config/no-access-message config)
             :styles {:padding 0}}]]]
         [labelled-input/view
          {:label     (loc/tr :vault-config/no-access-message)
           :value     (:vault-config/no-access-message config)
           :data-type :data.type/text-richtext
           :on-change (fn [v]
                        (rf/dispatch [::event/config-change :vault-config/no-access-message v]))}])

       #_[labelled-input/view
        {:label       (loc/tr :zap-vault-status)
         :value       (not (:common/archived? config))
         :editor-type :editor.type/toggle
         :on-change   (fn [v]
                        (rf/dispatch [::event/vault-change :common/archived? v]))}]

       [footer/footer
        [footer/left-align
         (when (seq changes)
           [button/secondary-hollow
            {:on-click #(rf/dispatch [::event/cancel-changes])}
            (loc/tr :cancel)])]
        [footer/right-align
         [button/primary-solid
          {:on-click  (fn [_]
                        (rf/dispatch [::event/save-changes changes]))
           :disabled? (empty? changes)}
          (loc/tr :save)]]]]]]))
